<template>
  <v-dialog
    :value="value"
    @input="handleInput"
    max-width="500px"
  >
    <avs-card>
      <template v-slot:title>
        <v-card-title class="pa-0"> {{ $t("commons.confirm") }} </v-card-title>
      </template>
      <template v-slot:content>
        <v-card-text>
          {{ $t("commons.confirm_question") }}<br />
          {{ $t("commons.confirm_prevention") }}
        </v-card-text>

        <v-card-actions class="d-flex justify-end gap-4">
          <avs-button
            color="blue white--text"
            iconI="mdi-check-circle-outline"
            noSpantext
            @click="handleConfirm"
          >
            <template v-slot:name>{{ $t("commons.yes") }}</template>
          </avs-button>

          <avs-cancelButton @click="handleCancel" />
        </v-card-actions>
      </template>
    </avs-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  components: {},
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleInput(newValue) {
      this.$emit("input", newValue)
    },
    handleCancel() {
      this.$emit("cancel")
    },
    handleConfirm() {
      this.$emit("confirm")
    }
  }
}
</script>
